<script>
import Layout from "../../../layouts/main"
import PageHeader from "@/components/page-header"
import appConfig from "@/app.config"
import { emailData } from "./data-inbox"
import CKEditor from "@ckeditor/ckeditor5-vue"
import ClassicEditor from "@ckeditor/ckeditor5-build-classic"
import Loader from "../../components/loader"


export default {
  page: {
    title: "Comunicação",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {
    Layout, PageHeader, Loader,
    ckeditor: CKEditor.component
  },
  data() {
    return {
      title: "Comunicação",
      items: [
        {
          text: "Clientes",
          href: "/"
        },
        {
          text: "Comunicação",
          active: true
        }
      ],
      updating: true,
      showModalNovaMSg: false,
      editor: ClassicEditor,
      editorData: "<p>Conteúdo da mensagem.</p>",
      msgsListData: null,

      showModalMsg: false,
      msgLeitura: {},
      represData: [
        {
          'nome': 'Representante 001',
          'leads': 0,
          'filtro': true
        },
        {
          'nome': 'Representante 002',
          'leads': 0,
          'filtro': true
        },
        {
          'nome': 'Representante 003',
          'leads': 0,
          'filtro': true
        },
        {
          'nome': 'Representante 004',
          'leads': 0,
          'filtro': true
        },
      ],

      filAfazer: true,
      filProspectado: false,
      filLeitConf: false,
      filNegoc: true,
      filConcret: false,
      filDesist: false,

      contAfazer: 0,
      contProspectado: 0,
      contNegoc: 0,
      contConcret: 0,
      contDesist: 0,
      contLeitConf: 0,

      canWhats: true,
      canEmail: true,
      canLinked: true,
      canInsta: true,
      canFaceb: true,

    }
  },

  computed: {

  },

  created() {
    this.carregarDados()

  },

  methods: {

    carregarDados(){
      console.log('carregarDados')
      this.updating = true
      setTimeout(() => {
        let msgsFinal = []
        let contTotal = 0
        this.contAfazer = 0
        this.contProspectado = 0
        this.contNegoc = 0
        this.contConcret = 0
        this.contDesist = 0
        this.contLeitConf = 0

        let canProcur = []
        let stsProcur = []
        if (this.canWhats){
          canProcur.push('whatsapp')
        }
        if (this.canEmail){
          canProcur.push('email')
        }
        if (this.canLinked){
          canProcur.push('linkedin')
        }
        if (this.canInsta){
          canProcur.push('instagram')
        }
        if (this.canFaceb){
          canProcur.push('facebook')
        }
        if (this.filAfazer){
          stsProcur.push('AF')
        }
        if (this.filProspectado){
          stsProcur.push('PR')
        }
        if (this.filNegoc){
          stsProcur.push('NG')
        }
        if (this.filConcret){
          stsProcur.push('CR')
        }
        if (this.filDesist){
          stsProcur.push('DS')
        }

        this.represData.forEach(repres => {
          repres.leads = 0
        })

        emailData.forEach(email => {
          if (canProcur.some(canal => email.canais.includes(canal))){
              if (stsProcur.includes(email.status)){
                const repFiltr = this.represData.find(item => item.nome === email.repres)
                repFiltr.leads++
                if (repFiltr.filtro){
                  if (this.filLeitConf){
                    if (email.leitura) {
                      msgsFinal.push(email)
                      contTotal++
                    }
                  } else {
                    msgsFinal.push(email)
                    contTotal++
                  }
                }
              }
          }
          switch (email.status) {
            case 'AF':
              this.contAfazer += 1
              break
            case 'PR':
              this.contProspectado += 1
              break
            case 'NG':
              this.contNegoc += 1
              break
            case 'CR':
              this.contConcret += 1
              break
            case 'DS':
              this.contDesist += 1
              break
          }
          if (email.leitura === true) {
            this.contLeitConf += 1
          }
        })
        this.title = 'COMUNICAÇÃO (' + contTotal + ')'
        this.msgsListData = msgsFinal
        this.updating = false
      }, 1000)
    },

    atuFiltroRepres(represRec){
      this.represData.forEach(repres => {
        if (repres.nome === represRec.nome){
          repres.filtro = !repres.filtro
        }
      })
      this.carregarDados()
    },

    iconeDoStatus(status) {
      let icone = ''
      let cor = ''
      switch (status) {
        case 'AF':
          icone = 'mdi-pencil-outline'
          cor = 'warning'
          break
        case 'PR':
          icone = 'mdi-send-check-outline'
          cor = 'info'
          break
        case 'NG':
          icone = 'mdi-diamond-stone'
          cor = 'danger'
          break
        case 'CR':
          icone = 'mdi-rocket-launch-outline'
          cor = 'success'
          break
        case 'DS':
          icone = 'mdi-trash-can-outline'
          cor = 'secondary'
          break
      }
      return [icone, cor]
    },

    corDoCanal(canal){
      let cor = 'success'
      switch (canal) {
        case 'whatsapp':
          cor = 'success'
          break
        case 'email':
          cor = 'danger'
          break
        case 'linkedin':
          cor = 'info'
          break
        case 'instagram':
          cor = 'warning'
          break
        case 'facebook':
          cor = 'info'
          break
      }
      return cor
    },

    abrirMensagem(mensagem){
      this.msgLeitura = mensagem
      this.showModalMsg = true
    },

  }
}

</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">

      <div class="col-12">

        <div class="email-leftbar card">
          <b-button variant="danger" @click="showModalNovaMSg = true">Nova</b-button>

          <div class="mail-list mt-4">
            <a href="#" :class="filAfazer ? 'active' : ''" @click="filAfazer = !filAfazer; carregarDados()">
              <i class="mdi mdi-pencil-outline me-2"></i> A Fazer
              <span class="ms-1 float-end" v-if="contAfazer > 0">({{ contAfazer }})</span>
            </a>
            <a href="#" :class="filNegoc ? 'active' : ''" @click="filNegoc = !filNegoc; carregarDados()">
              <i class="mdi mdi-diamond-stone me-2"></i>Negociação
              <span class="ms-1 float-end" v-if="contNegoc > 0">({{ contNegoc }})</span>
            </a>
            <a href="#" :class="filProspectado ? 'active' : ''" @click="filProspectado = !filProspectado; carregarDados()">
              <i class="mdi mdi-send-check-outline me-2"></i>Prospectado
              <span class="ms-1 float-end" v-if="contProspectado > 0">({{ contProspectado }})</span>
            </a>
            <a href="#" :class="filConcret ? 'active' : ''" @click="filConcret = !filConcret; carregarDados()">
              <i class="mdi mdi-rocket-launch-outline me-2"></i>Concretizados
              <span class="ms-1 float-end" v-if="contConcret > 0">({{ contConcret }})</span>
            </a>
            <a href="#" :class="filDesist ? 'active' : ''" @click="filDesist = !filDesist; carregarDados()">
              <i class="mdi mdi-trash-can-outline me-2"></i>Desistência
              <span class="ms-1 float-end" v-if="contDesist > 0">({{ contDesist }})</span>
            </a>
            <a href="#" :class="filLeitConf ? 'active' : ''" @click="filLeitConf = !filLeitConf; carregarDados()">
              <i class="mdi mdi-check-circle-outline me-2"></i>Leitura Confirmada
              <span class="ms-1 float-end" v-if="contLeitConf > 0">({{ contLeitConf }})</span>
            </a>
          </div>

          <h6 class="mt-4 text-end text-black-50">Canais</h6>
          <div class="mail-list mt-1">
            <a href="#" :class="canWhats ? 'text-black' : ''" @click="canWhats = !canWhats; carregarDados()">
              <span :class="`mdi mdi-whatsapp text-${canWhats ? 'success' : 'black-50'} float-end`"></span>Whatsapp
            </a>
            <a href="#" :class="canEmail ? 'text-black' : ''" @click="canEmail = !canEmail; carregarDados()">
              <span :class="`mdi mdi-email text-${canEmail ? 'danger' : 'balack-50'} float-end`"></span>E-mail
            </a>
            <a href="#" :class="canLinked ? 'text-black' : ''" @click="canLinked = !canLinked; carregarDados()">
              <span :class="`mdi mdi-linkedin text-${canLinked ? 'info' : 'balack-50'} float-end`"></span>LinkedIn
            </a>
            <a href="#" :class="canInsta ? 'text-black' : ''" @click="canInsta = !canInsta; carregarDados()">
              <span :class="`mdi mdi-instagram text-${canInsta ? 'warning' : 'black-50'} float-end`"></span>Instagram
            </a>
            <a href="#" :class="canFaceb ? 'text-black' : ''" @click="canFaceb = !canFaceb; carregarDados()">
              <span :class="`mdi mdi-facebook text-${canFaceb ? 'info' : 'balack-50'} float-end`"></span>Facebook
            </a>
          </div>

          <h6 class="mt-4 text-end text-black-50">Equipe</h6>
          <div class="mt-2">
            <a v-for="(repres,index) in represData" :key="index"
               @click="atuFiltroRepres(repres)"
               href="#" class="d-flex" >
              <img
                  :style="repres.filtro ? '' : 'filter: grayscale(100%)'"
                  class="d-flex me-3 rounded-circle"
                  src="@/assets/images/users/avatar.png"
                  alt="Generic placeholder image"
                  height="36"/>
              <div class="flex-grow-1 chat-user-box">
                <p :class="repres.filtro ? 'user-title m-0' : 'user-title m-0 text-muted'">{{ repres.nome }}</p>
                <p class="text-muted">{{ repres.leads }} {{ repres.leads > 1 ? 'leads' : 'lead' }}</p>
              </div>
            </a>
          </div>

        </div>


        <div class="email-rightbar mb-3">

          <Loader v-if="updating" style="min-height: 300px;">
          </Loader>

          <div class="card" v-if="!updating">
            <div class="btn-toolbar p-3">
              <div class="btn-group me-2 mb-2 mb-sm-0">
                <button type="button" class="btn btn-primary">
                  <i class="fa fa-inbox"></i>
                </button>
                <button type="button" class="btn btn-primary">
                  <i class="fa fa-exclamation-circle"></i>
                </button>
                <button type="button" class="btn btn-primary">
                  <i class="far fa-trash-alt"></i>
                </button>
              </div>

              <b-dropdown class="btn-group me-2 mb-2 mb-sm-0" variant="primary">
                <template v-slot:button-content>
                  <i class="fa fa-folder"></i>
                  <i class="mdi mdi-chevron-down ms-2"></i>
                </template>

                <a class="dropdown-item" href="javascript: void(0);">Orgânico</a>
                <a class="dropdown-item" href="javascript: void(0);">Redes Sociais</a>
                <a class="dropdown-item" href="javascript: void(0);">Google</a>
                <a class="dropdown-item" href="javascript: void(0);">Agente Indicador</a>
              </b-dropdown>

              <b-dropdown class="btn-group me-2 mb-2 mb-sm-0" variant="primary">
                <template v-slot:button-content>
                  <i class="fa fa-tag"></i>
                  <i class="mdi mdi-chevron-down ms-2"></i>
                </template>
                <a class="dropdown-item" href="javascript: void(0);">Descoberta</a>
                <a class="dropdown-item" href="javascript: void(0);">Consideração</a>
                <a class="dropdown-item" href="javascript: void(0);">Decisão</a>
              </b-dropdown>

              <b-dropdown class="btn-group me-2 mb-2 mb-sm-0" variant="primary">
                <template v-slot:button-content>
                  Pontuação
                  <i class="mdi mdi-dots-vertical ms-2"></i>
                </template>
                <b-dropdown-item href="javascript: void(0);">1 - Lead Frio</b-dropdown-item>
                <b-dropdown-item href="javascript: void(0);">2 - Lead Frio (+)</b-dropdown-item>
                <b-dropdown-item href="javascript: void(0);">3 - Lead Morno</b-dropdown-item>
                <b-dropdown-item href="javascript: void(0);">4 - Lead Morno (+)</b-dropdown-item>
                <b-dropdown-item href="javascript: void(0);">5 - Lead Quente</b-dropdown-item>
              </b-dropdown>
            </div>
            <div class="mt-3">

              <div class="table-responsive">
                <table class="table align-middle mb-0 table-nowrap">
                  <tbody>
                  <tr v-for="(email,index) in msgsListData" :key="index">
                    <td class="text-start" style="width: 20px;">
                      <a href="#" @click="abrirMensagem(email)">
                        <div class="checkbox-wrapper-mail">
                          <input :id="`chk-${index}`" type="checkbox" />
                          <label :for="`chk-${index}`"></label>
                        </div>
                      </a>
                    </td>

                    <td class="text-start" style="width: 150px;">
                      <a href="#" @click="abrirMensagem(email)">
                        <span class="title text-black">{{email.title}}</span>
                        <br>
                        <span :class="`badge badge-pill badge-soft-${iconeDoStatus(email.status)[1]} font-size-16 me-2`">
                          <i :class="`mdi ${iconeDoStatus(email.status)[0]}`"></i>
                        </span>
                        <span class="star-toggle far fa-check-circle text-success" v-if="email.leitura"></span>
                      </a>
                    </td>

                    <td class="text-start text-wrap" style="width: 50%;">
                      <a href="#" @click="abrirMensagem(email)">
                        <span class="">{{email.subject}}</span>
                        <br>
                        <span v-for="(canal, indexCan) in email.canais" :key="indexCan">
                          <span :class="`badge badge-pill badge-soft-${corDoCanal(canal)} font-size-16 me-2`">
                            <span :class="`mdi mdi-${canal} text-black-50`"></span>
                          </span>
                        </span>
                      </a>
                    </td>

                    <td class="text-end" style="width: auto;">
                      <a href="#" @click="abrirMensagem(email)">
                        {{ email.date }}
                        <br>
                        <span class="text-black-50"> {{ email.repres }} </span>
                      </a>
                    </td>

                  </tr>
                  </tbody>
                </table>
              </div>

            </div>
          </div>
          <div class="row justify-content-md-between align-items-md-center">

          </div>
        </div>
      </div>
    </div>

    <b-modal v-model="showModalNovaMSg" size="lg" title="Nova Mensagem" centered hide-footer>
      <form>
        <div class="mb-3">
          <input type="email" class="form-control" placeholder="Para" />
        </div>
        <div class="mb-3">
          <input type="text" class="form-control" placeholder="Assunto" />
        </div>
        <div class="mb-3">
          <ckeditor v-model="editorData" :editor="editor"></ckeditor>
        </div>
      </form>
      <div class="text-end mt-5">
        <b-button variant="light" @click="showModalNovaMSg = false">
          <i class="bx bx-block font-size-16 align-middle me-2"></i>
          Fechar
        </b-button>
        <b-button type="button" variant="success" class="ms-1" @click="showModalNovaMSg = false">
          <i class="bx bx-send font-size-16 align-middle me-2"></i>
          Enviar
        </b-button>
      </div>
    </b-modal>


    <b-modal v-model="showModalMsg" size="lg" title="Detalhes Mensagem" centered hide-footer>
      <div class="card-body">
        <div class="d-flex mb-4">
          <img
              class="d-flex me-3 rounded-circle avatar-sm"
              src="@/assets/images/users/avatar-2.jpg"
              alt="Generic placeholder image"/>
          <div class="flex-grow-1">
            <h5 class="font-size-14 mt-1">Representante 001</h5>
            <small class="text-muted">comercial@empresa.com</small>
          </div>
        </div>

        <h4 class="mt-0 font-size-16">{{msgLeitura.title}}</h4>

        <p>Solução Completa em ERP, WMS e TMS para Otimizar sua Gestão</p>
        <p>{{msgLeitura.subject}}</p>
        <p>Olá Empresa Testes 001 <br>
          Meu nome é Representante 001, represento a Econocargo, especializada no desenvolvimento de sistemas de gestão empresarial integrados.</p>
        <p></p>
        <p>Gostaria de apresentar nossa solução completa, que reúne:</p>
        <p>
          ✅ ERP — para uma gestão administrativa e financeira mais eficiente; <br>
          ✅ WMS — para otimizar e automatizar processos logísticos e de armazenagem; <br>
          ✅ TMS — para o planejamento e execução inteligente de transportes. <br>
        </p>
        <p>Nosso sistema é 100% integrado, personalizável e ideal para empresas que buscam:</p>
        <p>
          ✔️ Redução de custos operacionais <br>
          ✔️ Aumento de produtividade <br>
          ✔️ Tomada de decisão baseada em dados <br>
          ✔️ Melhoria na eficiência logística <br>
        </p>
        Gostaria de agendar uma demonstração rápida, sem compromisso, para entender melhor as necessidades da sua empresa e mostrar como podemos ajudar?
        <p>Fico à disposição,</p>
        <hr />
        <div class="row">
          <div class="col-xl-5 col-6">
            <div class="card">
              <img
                  style="width: 290px; height: 250px;"
                  src="@/assets/images/small/usuario-econopro-galpao.png"
                  alt="Card image cap"/>
            </div>
          </div>
          <div class="col-xl-5 col-6">
            <div class="card">
              <img
                  style="width: 290px; height: 250px;"
                  src="@/assets/images/small/caminhoes-econopro.png"
                  alt="Card image cap"/>
            </div>
          </div>
        </div>
        <a href="javascript: void(0);" class="btn btn-secondary waves-effect mt-4">
          <i class="mdi mdi-reply"></i> Interação
        </a>
      </div>

    </b-modal>

  </Layout>
</template>